import React, { useEffect } from 'react';
import defaultAvatar from '../assets/kavumainpageimg/default-avatar.svg';

const Modal = ({ type, data, onClose }) => {
    // Close modal on 'Escape' key press
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    const renderContent = () => {
        if (type === 'offeringDetails') {
            return (
                <>
                    <h3>{data.title}</h3>
                    <div dangerouslySetInnerHTML={{ __html: data.text }} />
                </>
            );
        }
        if (type === 'memberCard') {
            return (
                 <>
                    <img src={data.img || defaultAvatar} alt={data.name} style={{ maxWidth: '250px', borderRadius: '15px', objectFit: 'cover', display: 'block', margin: 'auto' }} />
                    <div className="member-info">{data.name}</div>
                    <div className="member-info" style={{ fontWeight: 'normal' }}>{data.designation || ''}</div>
                </>
            );
        }
        return null;
    };

    return (
        <div className="modal-overlay active" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={onClose}>×</button>
                {renderContent()}
            </div>
        </div>
    );
};

export default Modal;